import React from 'react'
import Link from 'gatsby-link'

import './document.css'

export default ({ data }) => {
  const post = data.markdownRemark
  return (
    <div className="app-document">
      <article>
        <Link className="link--back" to="/">
          Back to Rapport
        </Link>
        <h1>{post.frontmatter.title}</h1>
        <div dangerouslySetInnerHTML={{ __html: post.html }} />
      </article>
    </div>
  )
}

export const query = graphql`
  query DocumentQuery($slug: String!) {
    markdownRemark(fields: { slug: { eq: $slug } }) {
      html
      frontmatter {
        title
      }
    }
  }
`



// WEBPACK FOOTER //
// ./src/templates/document.js